import { render } from "./BaseSearchBar.vue?vue&type=template&id=1a5f7120&scoped=true"
import script from "./BaseSearchBar.vue?vue&type=script&lang=js"
export * from "./BaseSearchBar.vue?vue&type=script&lang=js"

import "./BaseSearchBar.vue?vue&type=style&index=0&id=1a5f7120&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a5f7120"]])

export default __exports__